import { getDicts } from '@/api/system/dict/data';
import { ref, toRefs } from 'vue';
import store from '@/store';

/**
 * 获取字典数据
 */
export function useDict(dictType) {
  return new Promise((resolve,reject) => {
    getDicts(dictType).then(resp => {
      let res = resp.data.map(p => ({
        label: p.dictLabel,
        value: p.dictValue
      }));
      resolve(res);
      // store.dispatch('dict/setDict', { key: dictType, value: res.data }
    });
  });

}
